/**
 * Timed lesson blocks (currently the Flanker task) must not keep running while
 * a dialog covers the screen — trials would elapse unanswered behind it and be
 * recorded as misses. Dialogs announce themselves here, so those blocks can
 * pause and resume without the lesson having to thread state through every
 * component in between.
 */

export const INTERRUPTION_START = 'lesson:interruption-start';
export const INTERRUPTION_END = 'lesson:interruption-end';

export const announceInterruptionStart = () => window.dispatchEvent(new Event(INTERRUPTION_START));

export const announceInterruptionEnd = () => window.dispatchEvent(new Event(INTERRUPTION_END));



// WEBPACK FOOTER //
// ./scripts/frontend/lessons/interruption.js